/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PersonIndexPathParams, PersonIndexQueryParams, PersonIndexResponse } from '../types/PersonIndex'

/**
 * GET /organisations/:organisationId/persons
 * @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::index
 */
export async function personIndex(
	organisationId: PersonIndexPathParams['organisationId'],
	params?: PersonIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PersonIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/persons`, { params, ...config })
}
